<template>
    <UsersEdit />
</template>

<script>
import {
    mapActions
} from 'vuex'

import UsersEdit from '../components/AdminPanelUsersEdit.vue'

export default {
    data: () => ({}),
    components: {
        UsersEdit
    },
    methods: {},
    mounted() {}
}
</script>
